import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SpecificationsList from './Specification/SpecificationsList'
import SpecificationTypeValueList from './SpecificationTypeValue/SpecificationTypeValueList'
import SpecificationTypesList from './SpecificationType/SpecificationTypesList'

const SpecificationTabbing = () => {
  const [activeToggle, setActiveToggle] = useState('specificationvalue')

  return (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={() => setActiveToggle('specificationvalue')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'specificationvalue' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Specification
                <hr />
              </span>
            </Link>
            <Link
              onClick={() => setActiveToggle('specificationtype')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'specificationtype' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Specification Type
                <hr />
              </span>
            </Link>
            <Link
              onClick={() => setActiveToggle('specificationtypevalue')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'specificationtypevalue' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Specification Type Value
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='specificationvalue'
              className={`tab-pane fade ${
                activeToggle === 'specificationvalue' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'specificationvalue' && <SpecificationsList />}
            </div>
            <div
              id='specificationtype'
              className={`tab-pane fade ${
                activeToggle === 'specificationtype' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'specificationtype' && (
                <SpecificationTypesList />
              )}
            </div>
            <div
              id='specificationtypevalue'
              className={`tab-pane fade ${
                activeToggle === 'specificationtypevalue' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'specificationtypevalue' && <SpecificationTypeValueList />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SpecificationTabbing
